import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import Icon from '../../../../../../components/Icon';

const ExtraRoomsButton = ({
  isOriginalRoom,
  isActive,
  isVip,
  baseCls,
  onClick,
  packageId,
}) => {
  const { t } = useTranslation();
  const btnCls = `${baseCls}-button`;

  const classes = cn(btnCls, {
    [`${btnCls}--original`]: isOriginalRoom,
    [`${btnCls}--vip`]: isVip, // last element
  });

  const defaultButtonText = t('checkout.extraRooms.button.default', {
    context: isActive ? 'active' : 'passive',
  });

  const newButtonText = t('checkout.extraRooms.button.new', {
    context: isActive ? 'active' : 'passive',
  });

  const buttonText = isOriginalRoom ? defaultButtonText : newButtonText;

  return (
    <Button
      size="flex"
      type="button"
      className={classes}
      disabled={isActive}
      functional={isActive}
      onClick={() => onClick(packageId)}
    >
      {isActive && !isOriginalRoom && (
        <div className={`${btnCls}__upgrade-icon`}>
          <Icon type="sign_additional" width="13px" height="auto" />
        </div>
      )}

      {isActive && isVip && <Icon width="21px" type="success_additional" />}

      {buttonText}
    </Button>
  );
};

ExtraRoomsButton.propTypes = {
  baseCls: PropTypes.string.isRequired,
  isOriginalRoom: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  isVip: PropTypes.bool.isRequired,
  packageId: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ExtraRoomsButton;
